import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { LIMAClient1Service } from './api/lIMAClient1.service';
import { LIMAPublic1Service } from './api/lIMAPublic1.service';
import { LIMASystem1Service } from './api/lIMASystem1.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    LIMAClient1Service,
    LIMAPublic1Service,
    LIMASystem1Service ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
